import { render, staticRenderFns } from "./CreateLastWillComponent.vue?vue&type=template&id=6b918be2&scoped=true&"
import script from "./CreateLastWillComponent.vue?vue&type=script&lang=js&"
export * from "./CreateLastWillComponent.vue?vue&type=script&lang=js&"
import style0 from "./CreateLastWillComponent.vue?vue&type=style&index=0&id=6b918be2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b918be2",
  null
  
)

export default component.exports